/** 共享接口客户端。 */

import { apiSend } from "./client";

export interface ShareIn {
  users: string[];
  group_ids: number[];
}

export interface ShareResult {
  ok: string[];
  failed: { open_id: string; error: string }[];
}

export function shareFavorite(
  favoriteId: number,
  payload: ShareIn,
): Promise<ShareResult> {
  return apiSend<ShareResult>(
    `/api/favorites/${favoriteId}/share`,
    "POST",
    payload,
  );
}

export function deleteFavorite(favoriteId: number): Promise<void> {
  return apiSend<void>(`/api/favorites/${favoriteId}`, "DELETE");
}
